export default __webpack_public_path__ + "static/media/twitch-seeklogo.com.38ac3b0e.svg";